import loanAgainstProperty from "./loanAgainstProperty";

import {
  websiteSchema,
  organizationSchema,
  financialServiceSchema,
  localBusinessSchema,
  breadcrumbSchema,
} from "@/components/common/schema";

const schemas = [
  websiteSchema(),
  organizationSchema(),
  financialServiceSchema(),
  localBusinessSchema(),
  breadcrumbSchema([
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Mortgage Loan",
      path: "/mortgage-loan",
    },
  ]),
];

const mortgageLoan = {
  ...loanAgainstProperty,

  seo: {
    ...loanAgainstProperty.seo,

    title: "Mortgage Loan | Money Mart",

    description:
      "Unlock the value of your residential or commercial property with a Mortgage Loan from leading Banks & NBFCs. Compare interest rates, higher loan amounts, and flexible repayment options with Money Mart.",

    keywords:
      "Mortgage Loan, Mortgage Loan Against Property, Property Mortgage Loan, Loan Against Property, Secured Loan, Money Mart",

    canonical: "/loan-against-property",

    structuredData: { schemas },
  },

  hero: {
    ...loanAgainstProperty.hero,

    badge: "Trusted Mortgage Loan Advisors",

    title: "Unlock the Value of Your Property with a Mortgage Loan",

    description:
      "Need funds for business expansion, education, medical expenses, debt consolidation, or any personal requirement? Money Mart helps you compare Mortgage Loan offers from leading Banks and NBFCs with expert guidance from application to disbursement.",

    image: "/images/loans/mortgage_loan.webp",
  },

  overview: {
    ...loanAgainstProperty.overview,

    badge: "Mortgage Loan",
    description:
      "A Mortgage Loan allows you to borrow against the market value of your residential or commercial property while retaining ownership.",
  },

  benefits: {
    ...loanAgainstProperty.benefits,
    title: "Why Choose a Mortgage Loan?",
    description:
      "A Mortgage Loan offers lower interest rates than unsecured loans while providing access to larger loan amounts.",
  },

  types: {
    ...loanAgainstProperty.types,
    title: "Mortgage Loan Solutions",

    description:
      "Choose the right mortgage loan based on your property type and financial requirements.",
  },

  eligibility: {
    ...loanAgainstProperty.eligibility,

    title: "Check Your Mortgage Loan Eligibility",
  },

  documents: {
    ...loanAgainstProperty.documents,

    title: "Documents Required for a Mortgage Loan",
    description:
      "The exact document requirements vary by lender and applicant profile. These are the commonly required documents for most Mortgage Loan applications.",
  },

  process: {
    ...loanAgainstProperty.process,

    title: "Your Mortgage Loan in 6 Simple Steps",
  },

  whyMoneyMart: {
    ...loanAgainstProperty.whyMoneyMart,

    description:
      "Compare Mortgage Loan offers from multiple lenders through a single application while receiving personalized guidance from experienced mortgage loan advisors.",
  },

  faq: {
    ...loanAgainstProperty.faq,

    title: "Mortgage Loan FAQs",

    description:
      "Find answers to the most commonly asked questions about Mortgage Loans.",

    items: loanAgainstProperty.faq.items.map((item) => ({
      ...item,
      question:
        item.question === "What is a Loan Against Property?"
          ? "What is a Mortgage Loan?"
          : item.question,
      answer:
        item.question === "What is a Loan Against Property?"
          ? "A Mortgage Loan is a secured loan where you pledge your residential or commercial property as collateral while retaining ownership."
          : item.answer,
    })),
  },

  cta: {
    ...loanAgainstProperty.cta,

    badge: "Need Funds Without Selling Your Property?",

    title: "Let's Find the Right Mortgage Loan for You",

    description:
      "Compare Mortgage Loan offers from leading Banks and NBFCs with expert assistance throughout your borrowing journey.",

    primaryButton: {
      text: "Apply for Mortgage Loan",
    },
  },

  leadForm: {
    ...loanAgainstProperty.leadForm,

    badge: "Free Mortgage Loan Consultation",

    title: "Speak to a Mortgage Loan Expert",

    description:
      "Our mortgage loan advisors will compare multiple lenders and help you secure the best Mortgage Loan based on your requirements.",
  },
};

export default mortgageLoan;
